"use strict";
var common_1 = require("@angular/common");
var edit_1 = require("@bhtp-client-api/edit");
var base_1 = require("@bhtp-client-api/base");
var PolicyDetailViewModel = (function () {
    function PolicyDetailViewModel() {
    }
    PolicyDetailViewModel.fromPolicyResponse = function (policyResponse) {
        var policyDetails = new PolicyDetailViewModel();
        if (policyResponse.policy) {
            policyDetails.packageName = policyResponse.policy.packageName;
            policyDetails.packageDisplaySubtitle = policyResponse.policy.packageDisplaySubtitle;
            policyDetails.productRatingId = policyResponse.policy.productRatingId;
            // This is the text version of the country name (Used to display on header)
            policyDetails.destination = policyResponse.policy.destination;
            // This is the iso 2 code of the country (used for trip details and quoting)
            policyDetails.destinationCountry = policyResponse.policy.destinationCountry;
            policyDetails.destinationCity = policyResponse.policy.destinationCity;
            policyDetails.destinationState = policyResponse.policy.destinationState;
            policyDetails.primaryTravelerName = policyResponse.policy.primaryTravelerName;
            policyDetails.departureDate = policyResponse.policy.departureDates.localized.dateString;
            policyDetails.returnDate = policyResponse.policy.returnDates.localized.dateString;
            policyDetails.packageRatingId = policyResponse.policy.packageRatingId;
            policyDetails.tripDepositDate = policyResponse.policy.tripDepositDate;
            policyDetails.fulfillmentMethod = policyResponse.policy.fulfillmentMethod;
            // Trip Suppliers
            policyDetails.airline = policyResponse.policy.airline;
            policyDetails.airlineNotProvided = !policyResponse.policy.airline;
            policyDetails.carRentalCompany = policyResponse.policy.carRentalCompany;
            policyDetails.cruiseLine = policyResponse.policy.cruiseLine;
            policyDetails.hotel = policyResponse.policy.hotel;
            policyDetails.rentalCompany = policyResponse.policy.rentalCompany;
            policyDetails.tourOperator = policyResponse.policy.tourOperator;
            // CRCC
            policyDetails.rentalCarPickupDate = policyResponse.policy.rentalCarPickupDate;
            policyDetails.rentalCarReturnDate = policyResponse.policy.rentalCarReturnDate;
            // display dates in mm/dd/yyyy format
            if (policyResponse.policy.purchaseDate) {
                policyDetails.purchaseDate = new common_1.DatePipe('en-US').transform(policyResponse.policy.purchaseDate, 'shortDate');
            }
            if (policyResponse.policy.localEffectiveDate) {
                policyDetails.localEffectiveDate = new common_1.DatePipe('en-US').transform(policyResponse.policy.localEffectiveDate, 'shortDate');
            }
            if (policyResponse.policy.localExpirationDate) {
                policyDetails.localExpirationDate = new common_1.DatePipe('en-US').transform(policyResponse.policy.localExpirationDate, 'shortDate');
            }
            // display currentcy in $10.99 format
            if (policyResponse.policy.premium !== null && policyResponse.policy.premium !== undefined) {
                policyDetails.price = new common_1.CurrencyPipe('en-US').transform(policyResponse.policy.premium, 'USD', true, '1.2-2');
            }
            if (policyResponse.policy.policyAddress) {
                policyDetails.residency = policyResponse.policy.policyAddress.stateOrProvince;
            }
        }
        policyDetails.tripCost = PolicyDetailViewModel.getTotalTripCost(policyResponse);
        policyDetails.paymentMethod = PolicyDetailViewModel.getPaymentMethod(policyResponse);
        return policyDetails;
    };
    PolicyDetailViewModel.toApiPolicy = function (source) {
        var target = new base_1.ApiPolicy();
        if (source) {
            target.productId = source.packageRatingId;
            target.isQuickQuote = true;
            target.destinationCountry = source.destinationCountry;
            target.fulfillmentMethod = source.fulfillmentMethod;
            // Setup return and departure dates
            var departureDate = new base_1.DateInformation();
            var returnDate = new base_1.DateInformation();
            departureDate.localized = new base_1.DateParts();
            returnDate.localized = new base_1.DateParts();
            departureDate.localized.fullDateTime = source.departureDate;
            returnDate.localized.fullDateTime = source.returnDate;
            target.returnDates = returnDate;
            target.departureDates = departureDate;
            target.tripDepositDate = source.tripDepositDate;
        }
        return target;
    };
    PolicyDetailViewModel.toApiEditPolicy = function (policyDetails) {
        var editPolicy = new edit_1.ApiEditPolicy();
        if (policyDetails) {
            editPolicy.productId = policyDetails.packageRatingId;
            editPolicy.isQuickQuote = false; // ?
            editPolicy.destinationCity = policyDetails.destinationCity;
            editPolicy.destinationState = policyDetails.destinationState;
            editPolicy.destinationCountry = policyDetails.destinationCountry;
            editPolicy.primaryTravelerName = policyDetails.primaryTravelerName;
            editPolicy.fulfillmentMethod = policyDetails.fulfillmentMethod;
            // Setup return and daparture Dates
            var departureDate = new base_1.DateInformation();
            var returnDate = new base_1.DateInformation();
            departureDate.localized = new base_1.DateParts();
            returnDate.localized = new base_1.DateParts();
            departureDate.localized.fullDateTime = policyDetails.departureDate;
            returnDate.localized.fullDateTime = policyDetails.returnDate;
            editPolicy.departureDates = departureDate;
            editPolicy.returnDates = returnDate;
            editPolicy.tripDepositDate = policyDetails.tripDepositDate;
            editPolicy.airline = policyDetails.airline;
            editPolicy.carRentalCompany = policyDetails.carRentalCompany;
            editPolicy.cruiseLine = policyDetails.cruiseLine;
            editPolicy.hotel = policyDetails.hotel;
            editPolicy.rentalCompany = policyDetails.rentalCompany;
            editPolicy.tourOperator = policyDetails.tourOperator;
        }
        return editPolicy;
    };
    PolicyDetailViewModel.transformForDateMask = function (date) {
        var transformedDate = '';
        var monthIndex = 1;
        var dayIndex = 2;
        var yearIndex = 0;
        var sourceDelimiter = '-';
        var targetDelimiter = '/';
        var dateParts = date.split(sourceDelimiter);
        if (dateParts.length >= 3) {
            var transformedDateParts = [dateParts[monthIndex], dateParts[dayIndex], dateParts[yearIndex]];
            transformedDate = transformedDateParts.join(targetDelimiter);
        }
        return transformedDate;
    };
    /**
     * sum the trip cost of each traveler to determine the total trip cost, and format that
     * @param policyResponse
     */
    PolicyDetailViewModel.getTotalTripCost = function (policyResponse) {
        var tripCost = 0;
        if (policyResponse.travelers) {
            policyResponse.travelers.forEach(function (t) {
                if (t.tripCost) {
                    tripCost += t.tripCost;
                }
            });
        }
        return new common_1.CurrencyPipe('en-US').transform(tripCost, 'USD', true, '1.2-2');
    };
    /**
     * find the first payment transaction to determine the payment method
     * @param policyResponse
     */
    PolicyDetailViewModel.getPaymentMethod = function (policyResponse) {
        if (policyResponse.transactions && policyResponse.transactions.payments &&
            policyResponse.transactions.payments.length > 0) {
            return policyResponse.transactions.payments[0].method;
        }
        return null;
    };
    return PolicyDetailViewModel;
}());
exports.PolicyDetailViewModel = PolicyDetailViewModel;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-models/policy-detail-view.model.js